/**
 * Custom Filters - Room Collection
 * Template-specific configuration for room/location collections
 *
 * Requires: custom-filters-core.js to be loaded first
 */

document.addEventListener('DOMContentLoaded', function() {
  // Get collection handle (slug) from URL
  let collectionHandle = window.location.pathname.split('/collections/')[1]?.split('/')[0] || 'all';

  // Room name mapping for handles that don't match the API's location value.
  // Shopify handleizes the collection title (e.g. "Kitchen & Dining" -> "kitchen-dining"),
  // dropping the spaces/ampersand the API expects. Map the URL handle to the real location name here.
  // The API is case-insensitive and core.js URL-encodes the value, so spaces and "&" pass through fine.
  // Simple single-word rooms (e.g. "office") need no entry — they fall through to the handle.
  const ROOM_NAME_MAPPING = {
    'shop-by-kitchen': 'kitchen',
    'shop-by-bedroom': 'bedroom',
    'entry-foyer': 'entry & foyer',
  };

  // Map the URL handle to the actual location name for API calls
  const apiParamValue = ROOM_NAME_MAPPING[collectionHandle.toLowerCase()] || collectionHandle;

  // Initialize with room-specific config.
  // The location name is passed to the filter API via the `location` param.
  window.CustomFilters.init({
    type: 'category',
    collectionHandle: collectionHandle,
    apiParamName: 'location',
    apiParamValue: apiParamValue,
    excludedFilters: ['categories', 'locations', 'trends', 'motorTypes'],
    extraApiParams: {}
  });
});
